import { useQuery } from "@apollo/client/react";
import waitForQueries from "components/waitForQueries";
import { GetApplicationContext } from "hooks/apollo/applicationContext/applicationContext.gql";
import useGetPermissions from "hooks/apollo/permissions/useGetPermissions";
import ApplicationLayout from "./ApplicationLayout";

function ApplicationLayoutContainer(props) {
  const queries = [useQuery(GetApplicationContext), useGetPermissions()];

  return waitForQueries({ queries, topLevel: true })(ApplicationLayout)(props);
}

export default ApplicationLayoutContainer;
